"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var branchIfPassesPredicate = function (propName, typePredicate, opts) {
    return ad_hok_1.branch(function (_a) {
        var _b = propName, propValue = _a[_b];
        return typePredicate(propValue);
    }, (opts === null || opts === void 0 ? void 0 : opts.returns) ? ad_hok_1.returns(opts.returns) : ad_hok_1.renderNothing());
};
exports.default = branchIfPassesPredicate;
